module.exports = __webpack_public_path__ + "static/media/logo.bdeda210.png";